const outcomes = [
  {
    icon: "ri-expand-left-right-line",
    title: "Expanded Reach &amp; Credibility",
    desc: "Reach more communities, more families, and more aspiring investors through a trusted, credible platform with deep diaspora roots.",
  },
  {
    icon: "ri-group-2-line",
    title: "Stronger Community Engagement",
    desc: "Build deeper, more meaningful connections with diaspora communities through structured, education-first programming and outreach.",
  },
  {
    icon: "ri-book-open-line",
    title: "Shared Educational Impact",
    desc: "Co-create programs that genuinely improve financial literacy, investor readiness, and long-term decision-making for the communities you serve.",
  },
  {
    icon: "ri-door-open-line",
    title: "New Pathways for Access",
    desc: "Open new doors for wealth-building access and investor readiness &mdash; creating tangible, lasting value for underserved and diaspora communities.",
  },
  {
    icon: "ri-time-line",
    title: "Long-Term Strategic Value",
    desc: "Build a structured, relationship-driven collaboration that creates compounding value over time &mdash; not just a one-off event or campaign.",
  },
];

export default function PartnershipOutcomes() {
  return (
    <section className="relative py-24 px-6 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="/assets/images/site/part-outcomes-001-1920x900.jpg"
          alt="Nairobi Kenya partnership outcomes Harambee Global Ventures"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-[#0D1F14]/88" />
      </div>

      <div className="relative z-10 max-w-[1280px] mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-flex items-center gap-2 text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-5">
            <span className="w-8 h-px bg-[#C9A961]" />
            Partnership Outcomes
            <span className="w-8 h-px bg-[#C9A961]" />
          </span>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-white leading-tight mb-5">
            What Partnership With Harambee Creates
          </h2>
          <p className="text-white/60 text-base leading-relaxed">
            When aligned organizations collaborate with Harambee, the impact extends far beyond the partnership itself &mdash; it ripples through communities, families, and futures.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {outcomes.slice(0, 3).map((item) => (
            <div
              key={item.title}
              className="bg-white/8 border border-white/15 rounded-lg p-8 hover:border-[#C9A961]/40 transition-all duration-300 group backdrop-blur-sm"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#C9A961]/15 mb-5 group-hover:bg-[#C9A961]/25 transition-colors">
                <i className={`${item.icon} text-[#C9A961] text-xl`} />
              </div>
              <h3
                className="font-['Cormorant_Garamond'] text-xl font-bold text-white mb-3"
                dangerouslySetInnerHTML={{ __html: item.title }}
              />
              <p className="text-white/55 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6 max-w-[860px] mx-auto">
          {outcomes.slice(3).map((item) => (
            <div
              key={item.title}
              className="bg-white/8 border border-white/15 rounded-lg p-8 hover:border-[#C9A961]/40 transition-all duration-300 group backdrop-blur-sm"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#C9A961]/15 mb-5 group-hover:bg-[#C9A961]/25 transition-colors">
                <i className={`${item.icon} text-[#C9A961] text-xl`} />
              </div>
              <h3
                className="font-['Cormorant_Garamond'] text-xl font-bold text-white mb-3"
                dangerouslySetInnerHTML={{ __html: item.title }}
              />
              <p className="text-white/55 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
